import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MainLayout } from '../../shared/components/layout/MainLayout';
import { NoAccessPage } from '../../modules/auth/presentation/pages/NoAccessPage';
import { LoginPage } from '../../modules/auth/presentation/pages/LoginPage';
import { SelectTerminalPage } from '../../modules/auth/presentation/pages/SelectTerminalPage';
import { VentaPage } from '../../modules/venta/presentation/pages/VentaPage';
import { ConfirmacionVentaPage } from '../../modules/venta/presentation/pages/ConfirmacionVentaPage';
import { HistorialPage } from '../../modules/historial/presentation/pages/HistorialPage';
import { HistorialDetallePage } from '../../modules/historial/presentation/pages/HistorialDetallePage';
import { SaldosPage } from '../../modules/saldos/presentation/pages/SaldosPage';
import { CotizacionPage } from '../../modules/cotizacion/presentation/pages/CotizacionPage';
import { PrivateRoute } from '../components/PrivateRoute';
import { useSession } from '../context/SessionContext';

const TERMINAL_DG_CODIGO = 10;

export const HistorialDetalleRoute: React.FC = () => {
  const { terminal } = useSession();
  const esDG = terminal?.codigo_terminal === TERMINAL_DG_CODIGO;
  return esDG ? <HistorialDetallePage /> : <Navigate to="/no-access" replace />;
};

export const VentaRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { terminal } = useSession();
  const esDG = terminal?.codigo_terminal === TERMINAL_DG_CODIGO;
  return esDG ? <Navigate to="/no-access" replace /> : <>{children}</>;
};

export const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rutas públicas */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/select-terminal" element={<SelectTerminalPage />} />

        {/* Rutas privadas — requieren autenticación */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <MainLayout>
                <Routes>
                  <Route path="/no-access" element={<NoAccessPage />} />
                  <Route path="/venta" element={<VentaRoute><VentaPage /></VentaRoute>} />
                  <Route path="/venta/confirmacion" element={<ConfirmacionVentaPage />} />
                  <Route path="/historial" element={<HistorialPage />} />
                  <Route path="/historial-detalle" element={<HistorialDetalleRoute />} />
                  <Route path="/saldos" element={<SaldosPage />} />
                  <Route path="/cotizacion" element={<CotizacionPage />} />
                  <Route path="*" element={<Navigate to="/no-access" replace />} />
                </Routes>
              </MainLayout>
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};
